import { LmsHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const PostCoachEnrollmentByEligbileCoachesData = (coachArrayObj, state, setState) => {
  if (state?.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const url = '/Enrollment/eligiblecoaches';
    LmsHttpHelper(url, 'POST', coachArrayObj)
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoaded: true,
            isSaving: false,
            isSaved: true,
            arrayData: arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};


export default PostCoachEnrollmentByEligbileCoachesData;